import { createTheme, ThemeProvider as MUIThemeProvider } from '@mui/material/styles';
import PropTypes from 'prop-types';

export const ThemeProvider = ({ children }) => {
  // Create theme object
  const theme = createTheme({
    palette: {
      primary: {
        main: '#f0f0f0',
        alt: '#3d4552',
        rieker: '#00B09B',
        riekerHover: '#009688',
      },
      secondary: {
        main: '#b0b0b0',
        alt: '#5a6c85',
        rieker: '#96C93D',
        riekerHover: '#8BC34A',
      },
      border: {
        main: '#9a9b99',
        light: '#e0e0e0',
        lighter: '#e8e8e8',
        accent: '#4DB6AC',
      },
      common: {
        white: '#fff',
        black: '#000',
        gray: '#f5f7f8',
        error: '#ff4444',
      },
      text: {
        primary: '#2c3e50',
        secondary: '#555555',
        light: '#64748b',
        helper: '#666666',
        white: '#ffffff',
      },
      background: {
        primary: '#9a9b99',
        default: '#f7f8fa',
        light: '#fafafa',
        lighter: '#f5f5f5',
        white: '#ffffff',
        disabled: '#f8f8f8',
      },
    },
    typography: {
      fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
      h4: {
        fontWeight: 600,
        letterSpacing: '0.5px',
      },
      button: {
        fontWeight: 600,
        letterSpacing: '1px',
      },
    },
    shadows: {
      none: 'none',
      video: '0px 2px 8px rgba(0, 0, 0, 0.08)',
      table: '6px 12px 8px 2px rgba(0, 0, 0, 0.2)',
      heavy: '0 20px 60px rgba(0, 0, 0, 0.15), 0 8px 16px rgba(0, 0, 0, 0.1)',
      focus: '0 8px 25px rgba(0, 176, 155, 0.15)',
      light: '0px 0px 20px #eee',
      disabled: 'linear-gradient(135deg, #cccccc 0%, #bbbbbb 100%)',
    },
    gradients: {
      primary: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      // primary: 'linear-gradient(135deg, #283048 0%, #859398 100%)',
    },
    shape: {
      borderRadius: 8,
    },
    breakpoints: {
      values: {
        xs: 0,
        sm: 600,
        md: 900,
        lg: 1200,
        xl: 1536,
      },
    },
    components: {
      MuiButton: {
        styleOverrides: {
          root: {
            borderRadius: 8,
          },
        },
      },
    },
  });

  return <MUIThemeProvider theme={theme}>{children}</MUIThemeProvider>;
};

ThemeProvider.propTypes = {
  children: PropTypes.any,
};
